import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckmark = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.384 2.670 C 11.338 2.687,11.254 2.730,11.197 2.765 C 11.141 2.800,9.780 4.142,8.173 5.748 L 5.251 8.667 4.055 7.477 C 2.663 6.092,2.736 6.148,2.333 6.148 C 2.109 6.148,2.077 6.154,1.955 6.216 C 1.516 6.439,1.344 6.937,1.551 7.390 C 1.605 7.509,1.794 7.707,3.169 9.081 C 4.543 10.456,4.741 10.645,4.860 10.699 C 5.113 10.815,5.387 10.815,5.640 10.699 C 5.761 10.644,6.111 10.302,9.082 7.332 C 12.052 4.361,12.394 4.011,12.449 3.890 C 12.656 3.437,12.484 2.938,12.046 2.716 C 11.932 2.659,11.883 2.649,11.691 2.643 C 11.544 2.639,11.440 2.648,11.384 2.670 ",
		stroke: "none",
		fillRule: "evenodd",
		fill: "currentColor"
	})
});
export default SvgCheckmark;
